import Seo from "@/components/site/Seo";
import PageHeader from "@/components/site/PageHeader";

function LegalBody({ sections }) {
  return (
    <section className="bg-rp-bg" data-testid="legal-body">
      <div className="mx-auto max-w-3xl px-6 py-16 md:py-24">
        <div className="space-y-10">
          {sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-display text-xl font-medium tracking-tight text-white">{s.h}</h2>
              {s.p.map((para, j) => (
                <p key={j} className="mt-3 text-base leading-relaxed text-white/55">{para}</p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Privacy() {
  const sections = [
    { h: "Overview", p: ["RestPower is an early-stage company in development. This Privacy Policy explains how we handle the limited information you choose to share with us through this website, such as newsletter signups and partnership inquiries."] },
    { h: "Information We Collect", p: ["We collect the information you voluntarily provide — for example, your name, email address, company, and message when you submit a partnership inquiry, or your email address when you join our mailing list."] },
    { h: "How We Use Information", p: ["We use your information to respond to inquiries, to share updates about RestPower's development and future locations, and to improve our concept. We do not sell your personal information."] },
    { h: "Email Communications", p: ["If you join our list, you may receive occasional updates. You can unsubscribe at any time using the link in our emails or by contacting us at info@restpower.app."] },
    { h: "Data Retention & Security", p: ["We retain the information you provide for as long as needed to fulfill the purposes described here, and we take reasonable measures to protect it."] },
    { h: "Contact", p: ["Questions about this policy can be sent to info@restpower.app."] },
  ];
  return (
    <>
      <Seo title="Privacy Policy — RestPower" description="How RestPower handles the limited information you share with us." path="/privacy" />
      <PageHeader overline="Legal" title="Privacy Policy" intro="Last updated as part of our early-stage development. This policy describes how we handle information shared through this website." />
      <LegalBody sections={sections} />
    </>
  );
}

export function Terms() {
  const sections = [
    { h: "Acceptance of Terms", p: ["By accessing restpower.app, you agree to these Terms of Use. RestPower is an early-stage company, and this website is provided for informational purposes about our concept and vision."] },
    { h: "Concept & Forward-Looking Content", p: ["This website communicates RestPower's vision and concept. Any architectural imagery of RestPower facilities is presented as concept visualization and does not depict existing locations. Content describing future plans is aspirational and subject to change; it does not represent operating locations, signed deals, or completed developments."] },
    { h: "Use of the Site", p: ["You agree to use this website lawfully and not to misuse any forms, submissions, or content provided here."] },
    { h: "Intellectual Property", p: ["The RestPower name, brand, and content on this site are the property of RestPower and may not be used without permission."] },
    { h: "Limitation of Liability", p: ["This website is provided 'as is'. To the fullest extent permitted by law, RestPower is not liable for any damages arising from your use of the site."] },
    { h: "Contact", p: ["Questions about these terms can be sent to info@restpower.app."] },
  ];
  return (
    <>
      <Seo title="Terms of Use — RestPower" description="The terms that govern your use of restpower.app." path="/terms" />
      <PageHeader overline="Legal" title="Terms of Use" intro="These terms govern your use of restpower.app, an informational website about our early-stage concept." />
      <LegalBody sections={sections} />
    </>
  );
}
